import {Form, Input} from 'antd';
import {FormInstance} from 'antd/es/form';
import {FormListFieldData} from 'antd/es/form/FormList';
import cn from 'classnames';
import React, {useState, FC, useEffect} from 'react';

import {CheckboxWithToggle} from 'components/@common/specific/сheckbox-with-toggle/checkbox-with-toggle';
import {ForeignParentInfoItem} from 'pages/ais/organization-structure-v5/ui/forms/group-company-protocol-form/group-company-org-Info-Item/foreign-parent-info-item';

import styles from './group-company-org-info-item.module.less';

interface IGroupCompanyOrgInfoItemProps {
    field: FormListFieldData;
    form?: FormInstance;
}

export const GroupCompanyOrgInfoItem: FC<IGroupCompanyOrgInfoItemProps> = ({
    field,
    form,
}: IGroupCompanyOrgInfoItemProps) => {
    const {hasForeignParent, foreignParentInfoDtos} = form?.getFieldValue(
        ['companyGroupProtoGroupInfoDtos', field.name],
    ) || {};
    const [fieldsCount, setFieldsCount] = useState<number | undefined>(0);
    const [areForeignParentsHidden, setAreForeignParentsHidden] = useState(false);

    useEffect(() => {
        if (foreignParentInfoDtos && foreignParentInfoDtos?.length !== 0) {
            setFieldsCount(foreignParentInfoDtos.length);
            setAreForeignParentsHidden(false);
        }
    }, [foreignParentInfoDtos]);

    return (
        <article
            key={field.name}
            className={styles['dependent-part-list__row']}
        >
            <section className={styles['dependent-part-list__top']}>
                <CheckboxWithToggle
                    selected={false}
                    disabled
                    onToggleSelect={() => {}}
                    fieldsCount={fieldsCount}
                    areConditionsHidden={areForeignParentsHidden}
                    setAreConditionsHidden={setAreForeignParentsHidden}
                    tooltipTitle="Показать дочерние элементы"
                    tooltipTitleEmpty="Нет дочерних элементов"
                />
                <section className="d-flex flex-column">
                    <div className={cn('d-flex gap-2 align-items-end', )}>
                        <Form.Item
                            label="Код группы компаний (холдинга)"
                            name={[field.name, 'groupCode']}
                            className={styles['dependent-part-list--half-width']}
                        >
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item
                            label="Наименование группы компаний (холдинга)"
                            name={[field.name, 'groupName']}
                            className={styles['dependent-part-list--half-width']}
                        >
                            <Input disabled/>
                        </Form.Item>
                    </div>
                    <div className="d-flex gap-2 align-items-end">
                        <Form.Item
                            label="ИНН российской головной организации группы компаний (холдинга)"
                            name={[field.name, 'headInn']}
                            className={styles['dependent-part-list--half-width']}
                        >
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item
                            label="ОГРН"
                            name={[field.name, 'ogrn']}
                            className={styles['dependent-part-list--half-width']}
                        >
                            <Input disabled/>
                        </Form.Item>
                    </div>
                    <div className="d-flex gap-2 align-items-end">
                        <Form.Item
                            label="Наименование российской головной организации группы компаний (холдинга)"
                            name={[field.name, 'headName']}
                            className={styles['dependent-part-list--half-width']}
                        >
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item
                            label="Признак наличия иностранной материнской компании у группы компаний или российской
                         головной организации группы компаний (холдинга)"
                            // name отсутствует, value задаем в зависимости от флага hasForeignParent
                            className={styles['dependent-part-list--half-width']}
                        >
                            <Input disabled value={hasForeignParent ? 'Да' : 'Нет'}/>
                        </Form.Item>
                    </div>
                </section>
            </section>
            <section className={styles['dependent-part-list__bottom']}>
                <div
                    className={cn({
                        [styles['dependent-part-list__bottom--line']]: !areForeignParentsHidden && !(fieldsCount === 0),
                    })}
                />
                <div
                    className={cn(styles['dependent-part-list__parents'], {
                        [styles['dependent-part-list__parents--hidden']]: areForeignParentsHidden,
                    })}
                >
                    <Form.List name={[field.name, 'foreignParentInfoDtos']}>
                        {(foreignParents) => (
                            <ForeignParentInfoItem
                                foreignParents={foreignParents}
                            />
                        )}
                    </Form.List>
                </div>
            </section>
        </article>
    );
};
